import { render, staticRenderFns } from "./delete-courses.html?vue&type=template&id=666dac14&scoped=true&"
import script from "./delete-courses.js?vue&type=script&lang=js&"
export * from "./delete-courses.js?vue&type=script&lang=js&"
import style0 from "./delete-courses.scss?vue&type=style&index=0&id=666dac14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666dac14",
  null
  
)

export default component.exports